'use client'

import { useFormContext } from 'react-hook-form'

import RequiredLabel from '@/components/Form/Atoms/RequiredLabel'
import '@/components/Form/Atoms/SelectBase/SelectBase.scss'

type Option = {
  label: string
  value: string
}
const SelectBase = ({
  name,
  label = null,
  autoComplete = null,
  required = false,
  placeholder,
  options,
}: {
  name: string
  label?: string | null
  autoComplete?: string | null
  required?: boolean
  placeholder?: string
  options: Option[]
}) => {
  const { register } = useFormContext()
  return (
    <div className="c-selectBase">
      {label !== null && (
        <label className="c-selectBase__label u-mb14" htmlFor={name}>
          {label}
          {required && <RequiredLabel marginLeft="1rem" />}
        </label>
      )}
      <select
        className="c-selectBase__select"
        id={name}
        {...register(name)}
        {...(autoComplete != null ? { autoComplete } : {})}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default SelectBase
